//states
const initialState = {
  source: "",
};

export { initialState };
